import { Footer } from '@easeltv/client-sdk';
import { useEffect, useRef, useState } from 'react';

import { useApi } from '../useApi/useApi';

export function useGetFooter(identifier?: string) {
    const [loading, setLoading] = useState(false);
    const [footer, setFooter] = useState<Footer>();

    const api = useApi();

    const request = useRef(async (footerId: string) => {
        setLoading(true);

        const result = await api.getFooter(footerId);

        if (!result.ok) {
            // @TODO: Error handling
            // eslint-disable-next-line no-console
            console.trace(result.payload);
        } else {
            const { body } = result.payload;
            setFooter(body);
        }

        setLoading(false);
    });

    useEffect(() => {
        if (identifier) request.current(identifier);
    }, [identifier]);

    return { loading, footer };
}
